import { PackageTypeEnum } from '@gtpl/shared-models/common-models';
import { ApiProperty } from "@nestjs/swagger";

export class SaleOrderItemsInfo {
    @ApiProperty()

    saleOrderItemId: number;
    @ApiProperty()

    saleOrderId: number;
    @ApiProperty()

    itemId: number;
    @ApiProperty()

    minGrade: number;
    @ApiProperty()

    maxGrade: number;
    @ApiProperty()

    foodTypeId: number;
    @ApiProperty()

    valueAdditionOneId: number;
    @ApiProperty()

    valueAdditionTwoId: number;
    @ApiProperty()

    valueAdditionThreeId: number;
    @ApiProperty()

    valueAdditionFourId: number;
    @ApiProperty()

    valueAdditionFiveId: number;
    @ApiProperty()

    pouches: number;
    @ApiProperty()

    cases: number;
    @ApiProperty()

    jobCases: number;
    @ApiProperty()

    caseWeight: number;

   
    @ApiProperty()

    netWeight: number;
    @ApiProperty()

    netAmount: number;
    @ApiProperty()

    createdUser: string;
    @ApiProperty()

    pouchWeight: number;
    @ApiProperty()

    categoryId: number;
    @ApiProperty()

    unitPrice: number;
    @ApiProperty()

    brandId: number;

    @ApiProperty()

    masterBrandId: number;

    @ApiProperty()

    uomId: number;
    @ApiProperty()

    packStyleId: number;
    // @ApiProperty()

    // freezeStle: number;

    @ApiProperty()
    minGlaze: number;
    @ApiProperty()
    MaxGlaze: number;
    @ApiProperty()
    soakingTime: string;
    @ApiProperty()

    soakingStyle: string;
    @ApiProperty()

    styleWeighment: string;
    @ApiProperty()

    varientId: number;
    @ApiProperty()

    skewerSizeItemId: number;
    @ApiProperty()

    innerBags: number;
    @ApiProperty()

    shrimpWeight: number;
    @ApiProperty()
    hlPercentage: number;
    @ApiProperty()
    finalPercentage: number;



    isActive: boolean;
    @ApiProperty()

    updatedUser: string;
    @ApiProperty()

    createdAt: Date;
    @ApiProperty()

    updatedAt: Date;
    @ApiProperty()

    versionFlag: number;

    @ApiProperty()

    category?: string;
    @ApiProperty()

    requiredCount?: number;
    @ApiProperty()

    reportedCases?: number;

    @ApiProperty()

    palletCapacity?: number;
    @ApiProperty()
    mainSoItemId: number;
    @ApiProperty()
    barcode?: string;
    // @ApiProperty()

    // subJobCodeListData?: any[];

    @ApiProperty()
    addonProduct?: boolean;


    @ApiProperty()
    productDescription?: string;

    @ApiProperty()
    itemCode?: string;

    @ApiProperty()
    duplicateGrade?: string;
    
    @ApiProperty()
    htsCode?: string;

    @ApiProperty()
    bundleCategory?: boolean;

    @ApiProperty()
    noOfBundles?: number;

    @ApiProperty()
    mcPerBundle?: number;

    @ApiProperty()
    priceBasedOn ?: number

    @ApiProperty()
    certificationId ?: number

    @ApiProperty()
    rating ?: number

    @ApiProperty()
    iscertification ?: string

    @ApiProperty()
    packageType ?: PackageTypeEnum

    @ApiProperty()
    tareWeight?: number
    


    /**
    * @param saleOrderItemId
    * @param saleOrderId
    * @param itemId
    * @param minGrade
    * @param maxGrade
    * @param foodTypeId
    * @param valueAdditionOneId
    * @param valueAdditionTwoId
    * @param valueAdditionThreeId
    * @param valueAdditionFourId
    * @param pouches
    * @param totalAmount
    * @param cases
    * @param caseWeight
    * @param netWeight
    * @param netAmount
    * @param createdUser
    * @param pouchWeight
    * @param category  
    * @param brandId  
    * @param uomId  
    * * @param freezeStle
    * @param minGlaze
    * @param MaxGlaze
    * @param soakingTime
    * @param soakingStyle
    * @param styleWeighment
    * @param valueAdditionFiveId
    * @param category
     */
    // constructor(saleOrderItemId: number, saleOrderId: number, itemId: number, minGrade: number, maxGrade: number, foodTypeId: number, valueAdditionOneId: number, valueAdditionTwoId: number, valueAdditionThreeId: number, valueAdditionFourId: number, pouches: number, cases: number, caseWeight: string, netWeight: string, netAmount: number, createdUser: string, pouchWeight: number, categoryId: number, unitPrice: number, brandId: number, uomId: number, freezeStle: number, minGlaze: number, MaxGlaze: number, soakingTime: string, soakingStyle: string, styleWeighment: string,valueAdditionFiveId: number) {
    //     this.saleOrderItemId = saleOrderItemId;
    //     this.saleOrderId = saleOrderId;
    //     this.itemId = itemId;
    //     this.minGrade = minGrade;
    //     this.maxGrade = maxGrade;
    //     this.foodTypeId = foodTypeId;
    //     this.valueAdditionOneId = valueAdditionOneId;
    //     this.valueAdditionTwoId = valueAdditionTwoId;
    //     this.valueAdditionThreeId = valueAdditionThreeId;
    //     this.valueAdditionFourId = valueAdditionFourId;
    //     this.pouches = pouches;
    //     this.cases = cases;
    //     this.caseWeight = caseWeight;
    //     this.netWeight = netWeight;
    //     this.netAmount = netAmount;
    //     this.createdUser = createdUser;
    //     this.pouchWeight = pouchWeight;
    //     this.categoryId = categoryId;
    //     this.unitPrice = unitPrice;
    //     this.brandId = brandId;
    //     this.uomId = uomId;
    //     this.freezeStle = freezeStle;
    //     this.minGlaze = minGlaze;
    //     this.MaxGlaze = MaxGlaze;
    //     this.soakingTime = soakingTime;
    //     this.soakingStyle = soakingStyle;
    //     this.styleWeighment = styleWeighment;
    //     this.valueAdditionFiveId = valueAdditionFiveId;
    //     this.createdUser = createdUser;
    //     this.createdUser = createdUser;
    // }
}